import React from 'react'

import css from './WelcomeMain.module.css'

const WelcomeMain = () => {
	return (
		<section className={css.welcomeSection}>
			<div className={css.welcomeContainer}>
				<p className={css.welcomeText}>
					Gabinet pomocy psychologicznej
					<br /> DAWID LEWKO
				</p>
			</div>
		</section>
	)
}

export default WelcomeMain